import { useMemo } from "react";
import { useWebsocket } from "./useWebsocket";
import { useProfile } from "@/query/profile";


export const useConnectedUsers = () => {
    const socket = useWebsocket();
    const { data: user } = useProfile();

    const isOtherConnected = useMemo(() => {
        return socket.connectUsers.some(connectedUser => connectedUser.user_id !== user?.user_id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [socket, socket.connectUsers, user]);

    return useMemo(() => {
        return {
            isOtherConnected
        };
    }, [isOtherConnected]);
};
